import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var FileAttachmentEmpty = () => /*#__PURE__*/_jsxs("svg", {
  width: "176",
  height: "224",
  viewBox: "0 0 176 224",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/*#__PURE__*/_jsx("rect", {
    width: "176",
    height: "224",
    fill: "white"
  }), /*#__PURE__*/_jsx("path", {
    d: "M55.5747 36.206H57.2547V32.666H59.9307V31.334H57.2547V29.186H60.7467V27.83H55.5747V36.206Z",
    fill: "#C2C2C3"
  }), /*#__PURE__*/_jsx("path", {
    d: "M62.338 36.206H64.018V27.83H62.338V36.206Z",
    fill: "#C2C2C3"
  }), /*#__PURE__*/_jsx("path", {
    d: "M66.0778 27.83V36.206H70.5178V34.874H67.7578V27.83H66.0778Z",
    fill: "#C2C2C3"
  }), /*#__PURE__*/_jsx("path", {
    d: "M76.8456 27.818H71.9856V36.206H76.8456V34.838H73.6656V32.618H76.4856V31.286H73.6656V29.186H76.8456V27.818Z",
    fill: "#C2C2C3"
  }), /*#__PURE__*/_jsx("path", {
    d: "M82.0317 36.206H83.7117V27.83H82.0317V36.206Z",
    fill: "#C2C2C3"
  }), /*#__PURE__*/_jsx("path", {
    d: "M85.7716 36.206H87.4516V30.758L89.7076 36.206H90.9796L93.2236 30.758V36.206H94.9036V27.83H93.0076L90.3436 34.058L87.6796 27.83H85.7716V36.206Z",
    fill: "#C2C2C3"
  }), /*#__PURE__*/_jsx("path", {
    d: "M102.653 36.206H104.429L101.417 27.818H99.4605L96.4485 36.206H98.2125L98.7645 34.61H102.101L102.653 36.206ZM101.645 33.266H99.2206L100.433 29.762L101.645 33.266Z",
    fill: "#C2C2C3"
  }), /*#__PURE__*/_jsx("path", {
    d: "M109.818 27.722C107.394 27.722 105.546 29.498 105.546 32.006C105.546 34.514 107.394 36.278 109.83 36.278C112.062 36.278 113.586 34.718 113.922 33.014V31.55H109.386V32.834H112.266C112.014 34.022 111.186 34.766 109.89 34.766C108.33 34.766 107.274 33.71 107.274 32.006C107.274 30.338 108.318 29.27 109.818 29.27C110.706 29.27 111.402 29.642 111.786 30.35H113.718C113.178 28.67 111.69 27.722 109.818 27.722Z",
    fill: "#C2C2C3"
  }), /*#__PURE__*/_jsx("path", {
    d: "M120.425 27.818H115.565V36.206H120.425V34.838H117.245V32.618H120.065V31.286H117.245V29.186H120.425V27.818Z",
    fill: "#C2C2C3"
  }), /*#__PURE__*/_jsx("rect", {
    x: "16",
    y: "68",
    width: "56",
    height: "4",
    rx: "2",
    fill: "#EDEDED"
  }), /*#__PURE__*/_jsx("rect", {
    x: "16",
    y: "56",
    width: "80",
    height: "8",
    rx: "4",
    fill: "#D8D8D8"
  }), /*#__PURE__*/_jsx("rect", {
    x: "16",
    y: "105",
    width: "40",
    height: "4",
    rx: "2",
    fill: "#EDEDED"
  }), /*#__PURE__*/_jsx("rect", {
    x: "136",
    y: "96",
    width: "24",
    height: "4",
    rx: "2",
    fill: "#D8D8D8"
  }), /*#__PURE__*/_jsx("rect", {
    x: "16",
    y: "96",
    width: "56",
    height: "4",
    rx: "2",
    fill: "#D8D8D8"
  }), /*#__PURE__*/_jsx("rect", {
    x: "16",
    y: "126",
    width: "40",
    height: "4",
    rx: "2",
    fill: "#EDEDED"
  }), /*#__PURE__*/_jsx("rect", {
    x: "136",
    y: "117",
    width: "24",
    height: "4",
    rx: "2",
    fill: "#D8D8D8"
  }), /*#__PURE__*/_jsx("rect", {
    x: "16",
    y: "117",
    width: "56",
    height: "4",
    rx: "2",
    fill: "#D8D8D8"
  }), /*#__PURE__*/_jsx("rect", {
    x: "16",
    y: "147",
    width: "40",
    height: "4",
    rx: "2",
    fill: "#EDEDED"
  }), /*#__PURE__*/_jsx("rect", {
    x: "136",
    y: "138",
    width: "24",
    height: "4",
    rx: "2",
    fill: "#D8D8D8"
  }), /*#__PURE__*/_jsx("rect", {
    x: "16",
    y: "138",
    width: "56",
    height: "4",
    rx: "2",
    fill: "#D8D8D8"
  }), /*#__PURE__*/_jsx("rect", {
    x: "16",
    y: "168",
    width: "40",
    height: "4",
    rx: "2",
    fill: "#EDEDED"
  }), /*#__PURE__*/_jsx("rect", {
    x: "136",
    y: "159",
    width: "24",
    height: "4",
    rx: "2",
    fill: "#D8D8D8"
  }), /*#__PURE__*/_jsx("rect", {
    x: "16",
    y: "159",
    width: "56",
    height: "4",
    rx: "2",
    fill: "#D8D8D8"
  }), /*#__PURE__*/_jsx("rect", {
    x: "120",
    y: "192",
    width: "40",
    height: "8",
    rx: "4",
    fill: "#D8D8D8"
  }), /*#__PURE__*/_jsx("rect", {
    x: "16",
    y: "192",
    width: "80",
    height: "8",
    rx: "4",
    fill: "#EDEDED"
  })]
});
//# sourceMappingURL=FileAttachmentEmpty.js.map